import * as runtypes from 'runtypes';

export const LoginType = runtypes.Union(runtypes.Literal('password'), runtypes.Literal('certificate'));

export type LoginType = runtypes.Static<typeof LoginType>;
